exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-color-slide[data-v-5bf68e5d] {\n  display:inline-block;\n  background: linear-gradient(269deg, #ddd, #eee);\n  background-size: 400% 400%;\n\t-webkit-animation: bg-pan-left-data-v-5bf68e5d 2s infinite both;\n\t        animation: bg-pan-left-data-v-5bf68e5d 2s infinite both;\n}\n@-webkit-keyframes bg-pan-left {\n0% {\n    background-position: 100% 50%;\n}\n50% {\n    background-position: 0% 50%;\n}\n100% {\n    background-position: 100% 50%;\n}\n}\n@keyframes bg-pan-left-data-v-5bf68e5d {\n0% {\n    background-position: 100% 50%;\n}\n50% {\n    background-position: 0% 50%;\n}\n100% {\n    background-position: 100% 50%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5bf68e5d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/SkeletonLoader.vue
// module id = 1560
// module chunks = 2